import type { JSX, MouseEventHandler } from 'react'
import { SocialShare } from '@/components/frontend/SocialShare'
import type { Post } from '@/payload-types'
import { OutlineButton } from './OutlineButton'
import { IconChevronLeft, IconChevronRight, IconRotateClockwise } from '@tabler/icons-react'
import { cn } from '@/utilities/ui'
import { Locale } from '@/providers/Locale/types'
import { i18n } from './i18n'

interface Props {
    locale: Locale
    post: Post
    slideNumber: number
    totalSlides: number
    onNavigationClick: MouseEventHandler<HTMLButtonElement>
}

const buttonClasses = 'bg-black text-white hover:bg-accent hover:text-white h-8'

export function SlideshowFooter({ locale, post, onNavigationClick, slideNumber, totalSlides }: Props): JSX.Element {
    return (
        <div className='hidden lg:block w-full fixed bottom-0 py-2 bg-black text-white z-10'>
            <nav className='container flex flex-wrap justify-between gap-4'>
                <div className='flex-grow basis-0'>
                    <div className='flex items-center justify-between max-w-[636px]'>
                        <OutlineButton onClick={onNavigationClick} data-direction='prev' className={cn(buttonClasses, { invisible: slideNumber === 1 })}>
                            <IconChevronLeft /> {i18n[locale].previous}
                        </OutlineButton>
                        <span className='text-lg whitespace-nowrap'>
                            {slideNumber} / {totalSlides + 1}
                        </span>
                        <OutlineButton onClick={onNavigationClick} data-direction='next' className={cn(buttonClasses, { hidden: slideNumber > totalSlides })}>
                            {i18n[locale].next} <IconChevronRight />
                        </OutlineButton>
                        <OutlineButton
                            onClick={onNavigationClick}
                            data-direction='restart'
                            className={cn(buttonClasses, { hidden: slideNumber <= totalSlides })}
                        >
                            <IconRotateClockwise className='mr-2' /> {i18n[locale].restart}
                        </OutlineButton>
                    </div>
                </div>
                <SocialShare variant='custom' post={post} classes={{ link: 'hover:bg-accent p-1' }} />
            </nav>
        </div>
    )
}
